<template>
  <b-modal
    id="app-key-regenerate-modal"
    ref="appKeyRegenerateModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to regenerate app keys? Note, that current app keys will become deprecated.</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="updating"
        @click="commitUpdate">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AppKeyRegenerateModal',
  data() {
    return {
      updating: false,
    };
  },
  computed: {
    ...mapGetters({
      appKeyUpdated: 'merchant/appKeyUpdated',
      apiError: 'merchant/apiError',
    }),
  },
  watch: {
    appKeyUpdated(updated) {
      if (updated) {
        this.$emit('updated', updated);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      updateAppKey: 'merchant/updateAppKey',
    }),
    commitUpdate() {
      this.updating = true;
      this.updateAppKey(this.$route.params.merchant_id);
    },
    show() {
      this.$refs.appKeyRegenerateModal.show();
    },
    hide() {
      this.updating = false;
      this.$refs.appKeyRegenerateModal.hide();
    },
  },
};
</script>
